export default {
    name: 'tests-question-text',
    props: {
        item: {},
        currentTest: {},
        isValid: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            text: ''
        }
    },
    methods: {
        handleInput() {
            this.$emit('update-question', this.text)
        }
    },
    destroyed() {
        this.$emit('update-question', '')
    }
}
